import Script from "next/script";
import { useFeatureFlags } from "~/lib/client/useFeatureFlags";
import { commonConfig } from "~/config/common-config";

export const OneTrustScripts: React.FC = () => {
  const { enableOneTrustBanner } = useFeatureFlags();

  if (!enableOneTrustBanner) {
    return null;
  }

  return (
    <>
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={
          commonConfig.NEXT_PUBLIC_ONETRUST_COOKIES_CONSENT_DOMAIN
        }
      />
      <Script
        type="text/javascript"
        id="cookie-consent-wrapper"
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() {}`,
        }}
      />
    </>
  );
};
